import { IRequest } from "coral-utility";
/*
 *   cart_new                            GET|POST   ANY      ANY    /api/cart/new
 *   cart_edit                           PUT|POST   ANY      ANY    /api/cart/{id}/edit
 *   add_model                           POST       ANY      ANY    /api/cart/addModel/{cart_id}/model/{model_id}
 *   remove_model                        POST       ANY      ANY    /api/cart/removeModel/{cart_id}/model/{model_id}
 *   cart_delete                         DELETE     ANY      ANY    /api/cart/{id}
 *   cart_get                            GET        ANY      ANY    /api/cart/{id}
 *   cart_index                          GET        ANY      ANY    /api/cart/
 */

export const carts = {
  newCart: (body: any): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/cart/new`,
    options: {
      method: "POST",
      body: JSON.stringify(body),
    },
  }),
  getCarts: (): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/cart/`,
    options: {
      method: "GET",
    },
  }),
  getCart: (cart: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/cart/{cart}`,
    options: {
      method: "GET",
    },
  }),
  addModel: (cart: string, model: string): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/cart/addModel/${cart}/model/${model}`,
    options: {
      method: "POST",
    },
  }),
  removeModel: (cart: string, model: string): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/cart/removeModel/${cart}/model/${model}`,
    options: {
      method: "POST",
    },
  }),
};
